import { render, staticRenderFns } from "./DialogLinkTasksToCourse.vue?vue&type=template&id=1dec26e2&scoped=true"
import script from "./DialogLinkTasksToCourse.vue?vue&type=script&lang=js"
export * from "./DialogLinkTasksToCourse.vue?vue&type=script&lang=js"
import style0 from "./DialogLinkTasksToCourse.vue?vue&type=style&index=0&id=1dec26e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec26e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dec26e2')) {
      api.createRecord('1dec26e2', component.options)
    } else {
      api.reload('1dec26e2', component.options)
    }
    module.hot.accept("./DialogLinkTasksToCourse.vue?vue&type=template&id=1dec26e2&scoped=true", function () {
      api.rerender('1dec26e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogLinkTasksToCourse.vue"
export default component.exports